/*
  RheasRaw: size buttons on product cards (snippets/product-grid-item.liquid), Oct 2026.
  A tap puts that size on the card's hidden quick-buy button and clicks it, so Empire's own
  add-to-basket (pop-up, "Goes well with", basket count) runs exactly as for single-size products.
  assets/rr-atc-source.js still logs these adds as grid / home / search.
*/
(function () {
  if (window.__rrSizePills) return;
  window.__rrSizePills = true;

  document.addEventListener('click', function (evt) {
    var pill = evt.target && evt.target.closest ? evt.target.closest('[data-rr-size-pill]') : null;
    if (!pill || pill.disabled) return;
    var card = pill.closest('[data-product-item]');
    var trigger = card && card.querySelector('.rr-size-pills__trigger[data-quick-buy]');
    if (!trigger) return;
    evt.preventDefault();
    trigger.setAttribute('data-variant-id', pill.getAttribute('data-variant-id'));
    pill.classList.add('is-adding');
    window.setTimeout(function () { pill.classList.remove('is-adding'); }, 1500);
    trigger.click();
  });
})();
